var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBbmPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18769_132136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5806 0C7.07826 0 3.42773 3.626 3.42773 8.09904C3.42773 10.3873 5.67243 14.487 5.67243 14.487L11.2801 24L17.131 14.598C17.131 14.598 19.7301 10.6865 19.7301 8.09904C19.7308 3.626 16.0809 0 11.5806 0ZM11.5424 12.5598C8.96384 12.5598 6.87519 10.4712 6.87519 7.88983C6.87519 5.31191 8.96316 3.22462 11.5424 3.22462C14.1197 3.22462 16.2104 5.31191 16.2104 7.88983C16.2104 10.4712 14.1197 12.5598 11.5424 12.5598Z",
    fill: "#50C878"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18769_132136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbmPointer);
export default __webpack_public_path__ + "static/media/BBM_Pointer.4dd4a04a388a8cd56322fa41174678a5.svg";
export { ForwardRef as ReactComponent };